import React from 'react';
import { useResponsive } from '@parsina/framework';

import ProfileWeb from './Profile.web.jsx';
import ProfileMobile from './Profile.mobile.jsx';

// پروفایل — two surfaces, one account.
//
// Both read the same derived `studentProfile` from the shared identity store and
// both write the same appearance choices into the same browser cache. Nothing on
// this screen is stored server-side, because the frozen contract has no mutation
// for any of it — the name and the phone number belong to Keycloak, and the
// appearance is per-browser.

const ProfileScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <ProfileMobile /> : <ProfileWeb />;
};

export default ProfileScreen;
